var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJozMaxx({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 323.85 323.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000202;\n        opacity: 0;\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.5,
    width: 322.85,
    height: 322.85
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.93,94.22h11.3v37.44c0,7.55-3.24,17.77-19.99,17.77s-20.75-12.95-20.75-20.81h11.3c0,5.58.06,12.44,9.33,12.44s8.88-7.04,8.88-12.5v-34.27h0l-.06-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M163.19,106.54c17.83,0,24.69,10.47,24.69,21.45s-6.85,21.45-24.69,21.45-24.69-10.47-24.69-21.45,6.85-21.45,24.69-21.45h0ZM163.19,141.44c10.09,0,13.83-6.54,13.83-13.45s-3.74-13.45-13.83-13.45-13.83,6.54-13.83,13.45,3.74,13.45,13.83,13.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M189.72,140.36l26.84-24.37h-25.45v-8h40.23v7.04l-27.35,24.81h28.37v8h-42.65v-7.55h0v.06Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.52,181.04h19.67l22.78,41,22.59-41h19.48v52.93h-12.82l.51-43.72h-.19l-23.99,43.72h-11.68l-23.92-43.72h-.19l.51,43.72h-12.76v-52.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.88,181.04h16.18l29,52.93h-15.23l-6.79-13.07h-30.59l-6.73,13.07h-14.79l29-52.93h-.13.06ZM144.98,212.51l-11.11-22.27-11.3,22.27h22.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.6,206.74l-26.53-25.57h17.01l17.9,18.4,18.21-18.4h16.5l-26.59,25.57,26.59,27.29h-17.32l-17.71-19.48-17.83,19.48h-16.82l26.53-27.29h.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M269.24,206.74l-26.53-25.57h17.01l17.9,18.4,18.21-18.4h16.5l-26.59,25.57,26.59,27.29h-17.32l-17.71-19.48-17.83,19.48h-16.82l26.53-27.29h.06Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJozMaxx);
export default __webpack_public_path__ + "static/media/joz-maxx.bc5301e0a86222e28d7a6aaf0a665a0b.svg";
export { ForwardRef as ReactComponent };